import Brand from 'records/Brand';
import Base from 'records/Base';

import {
  BRAND_ASYNC_ACTION_START,
  BRAND_ASYNC_ACTION_ERROR,
  BRAND_ASYNC_UPDATE_SUCCESS,
  BRAND_UPDATE_SUCCESS,
  BRAND_RESET_STATE,
} from 'actions/brand';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Brand(),
});

const actionsMap = {
  [BRAND_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [BRAND_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [BRAND_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Brand(action.data),
    });
  },
  [BRAND_UPDATE_SUCCESS]: (state, action) => {
    return state.mergeDeep({
      data: action.data,
    });
  },
  [BRAND_RESET_STATE]: () => {
    return initialState;
  },
};

export default function brand(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
